import {ERROR_CODE} from "./ERROR_CODE";

export class RecursionOnHierarchy extends Error {
    code = ERROR_CODE.RECURSION;
    targetId: string;
    childId: string;
    constructor(targetId: string, childId: string) {
        super(`Recursion child is not allowed: attempt to add ${childId} tp ${targetId} childs`);
        this.targetId = targetId;
        this.childId = childId;
    }
}

export const isErrorRecursionOnHierarchy = (error: unknown): error is RecursionOnHierarchy => {
    return (error as RecursionOnHierarchy).code === ERROR_CODE.RECURSION
}
